import { Car02Icon, Motorbike01Icon, Restaurant02Icon } from "@hugeicons/core-free-icons";
import { orange, blue, teal } from "@mui/material/colors";

export const ONE_MB = 1024 * 1024;
export const TWO_MB = ONE_MB * 2;
export const THREE_MB = ONE_MB * 3;
export const FOUR_MB = ONE_MB * 4;

export const CLOUD_FUNCTIONS_BASE_URL = "https://us-central1-menuapp-b44a8.cloudfunctions.net";

// Regex
export const slugRegex = /^(?!-)(?!.*--)[a-z0-9]+(-[a-z0-9]+)*$/;
export const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

export const INITIAL_LOCATION = { lat: 12.115, lng: -86.2362 };

export enum MENU_FLOWS {
  DELIVERY = "delivery",
  PICK_UP = "pick-up",
  DINE_IN = "dine-in",
}

export const MENU_FLOW_LABELS = {
  [MENU_FLOWS.DELIVERY]: "Delivery",
  [MENU_FLOWS.PICK_UP]: "Pick Up",
  [MENU_FLOWS.DINE_IN]: "Dine In",
};

export const DINING_MODES = [
  {
    id: MENU_FLOWS.DELIVERY,
    title: "A domicilio",
    description: "Recibe tu pedido en casa o donde estés",
    icon: Motorbike01Icon,
    color: orange,
  },
  {
    id: MENU_FLOWS.PICK_UP,
    title: "Para recoger",
    // title: "Para llevar",
    description: "Pides en la app y lo recoges en el restaurante",
    icon: Car02Icon,
    color: blue,
  },
  {
    id: MENU_FLOWS.DINE_IN,
    title: "Comer aquí",
    description: "Disfruta tu comida en el restaurante",
    icon: Restaurant02Icon,
    color: teal,
  },
];

export const IMAGE_PLACEHOLDER = "/placeholder.png";
export const BASE_IMAGE_URL = `https://storage.googleapis.com/menuapp-b44a8.appspot.com`;

export enum DATE_RANGE {
  LAST_SEVEN_DAYS = "last-seven-days",
  LAST_THIRTY_DAYS = "last-thirty-days",
}

export const DATE_RANGES = {
  [DATE_RANGE.LAST_SEVEN_DAYS]: {
    days: 7,
    label: "Últimos 7 días",
  },
  [DATE_RANGE.LAST_THIRTY_DAYS]: {
    days: 30,
    label: "Últimos 30 días",
  },
};

export enum ORDER_SOURCES {
  BITELINK = 'bitelink',
  WHATSAPP = 'whatsapp',
  SOCIALS = 'socials',
  CALL = 'call',
}

export const ORDER_SOURCE_LABELS = {
  [ORDER_SOURCES.BITELINK]: "BiteLink",
  [ORDER_SOURCES.WHATSAPP]: "WhatsApp",
  [ORDER_SOURCES.SOCIALS]: "Redes Sociales",
  [ORDER_SOURCES.CALL]: "Teléfono",
}


export const ORDER_SOURCE_OPTIONS = Object.values(ORDER_SOURCES).map((source) => ({
  value: source,
  label: ORDER_SOURCE_LABELS[source],
}));
